import { Overlay } from 'components/Overlay';
import * as React from 'react';
import { getStoreState } from 'state/Store';
import styled from 'styled-components';
import { trackEvent } from 'utils/Tracker';

const Popup = styled.div`
  max-width: 1320px;
  width: 90%;
  display: flex;
  align-items: stretch;
  min-height: 300px;
`;

const Text = styled.div`
  padding: 8px 32px;
  text-align: left;
  width: 67%

  font-size: 16px;
  line-height: 19px;

  h2 {
    font-size: 24px;
    line-height: 29px;
  }

  footer {
    color: var(--secondary-text-color);
    font-size: 14px;
    line-height: 17px;
  }

  > * {
    margin: 24px 0;
  }
`;

const Video = styled.video`
  background: #ddd;
  width: 33%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  overflow: hidden;
`;

const Item = styled.li`
  margin: 16px 0;
  display: flex;
  align-items: center;
  svg {
    color: var(--accent-color);
    margin-right: 8px;
  }
`;

export const BuyFigmaSubscriptionModal: React.FC = () => {
  const { figmaPaymentStatus } = getStoreState().app;
  const notAvailable = figmaPaymentStatus === 'NOT_SUPPORTED';
  const buy = React.useCallback(() => {
    trackEvent('Buy Figma Intent');
    parent?.postMessage({ type: 'initiateCheckout' }, '*');
  }, []);
  return (
    <Overlay fullWidth={true}>
      <Popup>
        <Text>
          <h2>Upgrade for sound-reactive effects and more</h2>
          <div>
            Buy the <strong>$10/month</strong> subscription to:
          </div>
          <ul>
            <Item>
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.5 17.1667C7.5 18.4167 6.38083 19.6667 5 19.6667C3.62 19.6667 2.5 18.5475 2.5 17.1667C2.5 15.7867 3.62 14.6667 5 14.6667H7.5V17.1667V17.1667Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.6667 13.8333C16.6667 15.0833 15.5475 16.3333 14.1667 16.3333C12.7867 16.3333 11.6667 15.2142 11.6667 13.8333C11.6667 12.4533 12.7867 11.3333 14.1667 11.3333H16.6667V13.8333V13.8333Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.5 14.6667V4.66666L16.6667 0.916664V11.3333"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.5 7.58333L16.6667 3.83333"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              Add soundtracks (royalty-free, Apple Music, or upload yours)
            </Item>
            <Item>
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.25002 20.0833L8.75002 10.9167H5.41669L7.91669 0.916668H14.5834L10.4167 7.58333H14.5834L6.25002 20.0833Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
              Animate effects using several audio signals
            </Item>
            <Item>
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75903 18.2499H5.2642"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.75903 15.2417H5.2642"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.75903 12.2334H5.2642"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 18.2499H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 15.2417H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 12.2334H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 9.22507H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 6.2375H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.91663 3.25016H12.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.7219 18.2499H18.2505"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.7219 15.2417H18.2505"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Add audio visualizations
            </Item>
            <Item>
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.41669 3.41667C1.41669 2.49667 2.16335 1.75 3.08335 1.75H18.9167C19.8367 1.75 20.5834 2.49667 20.5834 3.41667V17.5833C20.5834 18.5033 19.8367 19.25 18.9167 19.25H3.08335C2.16335 19.25 1.41669 18.5033 1.41669 17.5833V3.41667V3.41667Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.75 9.276V9.25017C9.75 8.32933 9.00333 7.5835 8.08333 7.5835H6.41667C5.49667 7.5835 4.75 8.32933 4.75 9.25017V11.7502C4.75 12.6702 5.49667 13.4168 6.41667 13.4168H8.08333C9.00333 13.4168 9.75 12.6702 9.75 11.7502V11.7318"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.25 9.276V9.25017C17.25 8.32933 16.5033 7.5835 15.5833 7.5835H13.9167C12.9967 7.5835 12.25 8.32933 12.25 9.25017V11.7502C12.25 12.6702 12.9967 13.4168 13.9167 13.4168H15.5833C16.5033 13.4168 17.25 12.6702 17.25 11.7502V11.7318"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Transcribe audio into animated captions
            </Item>
            <Item>
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M20.5834 15.0833C20.5834 15.5442 20.2109 15.9167 19.75 15.9167H2.25002C1.79085 15.9167 1.41669 15.5442 1.41669 15.0833V2.58333C1.41669 2.1225 1.79085 1.75 2.25002 1.75H19.75C20.2109 1.75 20.5834 2.1225 20.5834 2.58333V15.0833V15.0833Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.83337 18.4167H15.1667"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.75 15.9167V18.4167"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.25 15.9167V18.4167"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0834 11.75V5.08333H14.3059C15.8092 5.08333 16.6159 6.57667 16.6159 8.41667C16.6159 10.2567 15.8092 11.75 14.3059 11.75H13.0834V11.75Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.75 5.08333V11.75"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.58337 5.08333V11.75"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.58337 8.41667H9.75004"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Better video quality
            </Item>
            <Item>
              <svg
                width="22"
                height="21"
                viewBox="0 0 22 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.9167 7.58333L20.5834 0.916664"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.41669 20.0833L8.08335 13.4167"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M18.0834 7.58333H13.9167V3.41666"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.08335 17.5833V13.4167H3.91669"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.9167 13.4167L20.5834 20.0833"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.41669 0.916664L8.08335 7.58333"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.9167 17.5833V13.4167H18.0834"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.91669 7.58333H8.08335V3.41666"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Reduce substantially animated GIFs file size
            </Item>
          </ul>
          <div>
            <button
              className="large primary"
              style={{ textTransform: 'capitalize' }}
              onClick={buy}
              disabled={notAvailable}
            >
              {notAvailable ? 'Coming March 7th' : 'Buy subscription'}
            </button>
          </div>
          <footer>
            Looking for more features like ready-made templates, creating flyers
            on mobile, and more? Check out{' '}
            <a href="https://editor.beatflyer.com/?ref=figma" target="_blank">
              Beatflyer standalone
            </a>
            .
          </footer>
        </Text>
        <Video
          controls={false}
          autoPlay={true}
          playsInline={true}
          muted={true}
          loop={true}
        >
          <source src="https://s3-eu-west-1.amazonaws.com/beatflyer-test/downloads/buy-figma.mp4" />
        </Video>
      </Popup>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/modals/BuyFigmaSubscription.tsx